import { ArrowLeftIcon } from "@phosphor-icons/react";
import { useRouter } from "@tanstack/react-router";
import clsx from "clsx";
import type { MouseEventHandler } from "react";

import { IconButton } from "@/components/IconButton/IconButton";

type Props = {
  iconClassName?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

export const BackButton = ({
  onClick,
  iconClassName = "fill-text-interactive",
}: Props) => {
  const { history } = useRouter();

  return (
    <IconButton onClick={(e) => (onClick ? onClick(e) : history.back())}>
      <ArrowLeftIcon
        size={24}
        className={clsx(iconClassName, "rtl:-scale-x-100")}
      />
    </IconButton>
  );
};
